import React, { Fragment, useState } from "react";
import {
  Grid,
  Button,
  Divider,
  Card,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { Link } from "react-router-dom";
//componentes de la Vista
import AuthUser from "./authUser";
import Loader from "widgets/Loader";
//estilos
import "./login.css";
import { useStyles } from "./styles";
import ManualesModal from "./ManualesModal.js";
import MsgPhones from "./MsgPhones";
import MsmWelcome from "./MsmWelcome";
import useLogin from "./useLogin";
import RecoveryCredential from "./recoveryCredential";

const Login = () => {
  const classes = useStyles();
  const {
    handleRedirectionRegister,
    handleAutentication,
    handleChange,
    error,
    errorInputs,
    user,
  } = useLogin();

  const [showPassword, setShowPassword] = useState(false);
  return (
    <Fragment>
      <Loader />
      <Grid>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="center"
          className={classes.root}
        >
          <Card className={classes.card}>
            <form onSubmit={handleAutentication}>
              <AuthUser />
              {errorInputs ? <p>Ingrese todos los campos</p> : null}
              <Grid
                container
                justify="center"
                align="center"
                direction="row"
                spacing={1}
              >
                <img
                  src="../facturar12020.png"
                  alt="logo"
                  className={classes.large}
                />
              </Grid>
              <br></br>
              <MsgPhones />
              <MsmWelcome />
              <br></br>

              <Divider></Divider>
              <br />
              {error ? (
                <div className="alert alert-danger" role="alert">
                  <label> {error}</label>
                </div>
              ) : null}
              <Grid item md={12}>
                <TextField
                  type="text"
                  classes={{
                    root: classes.input,
                  }}
                  onChange={handleChange}
                  required
                  name="username"
                  autoComplete="off"
                  value={user.username}
                  label="Usuario"
                  variant="outlined"
                />
              </Grid>
              <Grid item md={12}>
                <TextField
                  type={showPassword ? "text" : "password"} 
                  classes={{
                    root: classes.input,
                  }}
                  onChange={handleChange}
                  required
                  name="password"
                  value={user.password}
                  label="Contraseña"
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(prev => !prev)}
                          edge="end"
                          aria-label="toggle password visibility"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item md={12} className={classes.link}>
                <RecoveryCredential />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonLogin}
                  type="submit"
                  fullWidth
                >
                  Ingresar
                </Button>
              </Grid>
            </form>

            <ManualesModal></ManualesModal>
            <Grid item md={12}>
              <Typography className={classes.questionLogin}>
                ¿Aún no está en Facturar?
              </Typography>
            </Grid>

            <Grid item md={12} className={classes.registro}>
              <Link
                to="/registro"
                variant="contained"
                color="primary"
                fullWidth
                underline="always"
                className={classes.link}
              >
                Regístrarse
              </Link>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Login;